module.exports = __webpack_public_path__ + "static/media/team-member-01.099115eb.jpg";